@if (data) {
    @if (data.templateRef) {
        <ng-container [ngTemplateOutlet]="data.templateRef" />
    } @else {
        <ng-template #dynamicContent />
    }
}
